// const norm = (s) => (s || "").toLowerCase().trim();

export default function FiltersBar({
  value,
  onChange,
  counts,
  showingMeta,
}) {
  const { query, author, genre, status, minRating, sort } = value;

  function handle(e) {
    const { name, value } = e.target;
    onChange?.({ [name]: value });
  }

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 16,
        border: "1px solid #cbd5e1",
        padding: 16,
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(160px,1fr))",
        gap: 16,
      }}
    >
      <div>
        <label style={{ fontSize: 12, fontWeight: 500 }}>Search</label>
        <input
          name="query"
          value={query}
          onChange={handle}
          placeholder="title or author..."
          style={inputStyle}
        />
      </div>

      <div>
        <label style={{ fontSize: 12, fontWeight: 500 }}>Author</label>
        <input
          name="author"
          value={author}
          onChange={handle}
          placeholder="James Clear..."
          style={inputStyle}
        />
      </div>

      <div>
        <label style={{ fontSize: 12, fontWeight: 500 }}>Genre</label>
        <input
          name="genre"
          value={genre}
          onChange={handle}
          placeholder="engineering, mindset..."
          style={inputStyle}
        />
      </div>

      <div>
        <label style={{ fontSize: 12, fontWeight: 500 }}>Shelf</label>
        <select
          name="status"
          value={status}
          onChange={handle}
          style={inputStyle}
        >
          <option value="all">All ({counts.all})</option>
          <option value="tbr">To Read ({counts.tbr})</option>
          <option value="reading">Reading ({counts.reading})</option>
          <option value="finished">Finished ({counts.finished})</option>
        </select>
      </div>

      <div>
        <label style={{ fontSize: 12, fontWeight: 500 }}>Min Rating</label>
        <select
          name="minRating"
          value={minRating}
          onChange={handle}
          style={inputStyle}
        >
          <option value={0}>Any</option>
          <option value={1}>1★+</option>
          <option value={2}>2★+</option>
          <option value={3}>3★+</option>
          <option value={4}>4★+</option>
          <option value={5}>5★ only</option>
        </select>
      </div>

      <div>
        <label style={{ fontSize: 12, fontWeight: 500 }}>Sort</label>
        <select name="sort" value={sort} onChange={handle} style={inputStyle}>
          <option value="date-added-desc">Newest first</option>
          <option value="date-added-asc">Oldest first</option>
          <option value="title-asc">Title A→Z</option>
          <option value="title-desc">Title Z→A</option>
          <option value="rating-desc">Rating high→low</option>
        </select>
      </div>

      <div
        style={{
          fontSize: 12,
          lineHeight: 1.4,
          color: "#475569",
          background: "#f8fafc",
          border: "1px solid #cbd5e1",
          borderRadius: 12,
          padding: 12,
        }}
      >
        Showing <b>{showingMeta.shown}</b> of {showingMeta.total}
      </div>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  border: "1px solid #94a3b8",
  borderRadius: 8,
  padding: "8px 10px",
  fontSize: 14,
  marginTop: 4,
};

